module.exports = __webpack_public_path__ + "cc5f0a97e4a4998768d19e94aa26ea06.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/gougou.png
// module id = 450
// module chunks = 0